module.exports = __webpack_public_path__ + "img/icono_1.8c791bf1.svg";